module.exports = __webpack_public_path__ + "img/itemico5.9583f2f2.png";